export function Hero() {
  return (
    <section className="bg-gradient-to-br from-primary-50 to-blue-100 section-padding">
      <div className="container-wrapper">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 animate-fade-in">
            Ask in plain English.
            <br />
            <span className="text-primary-600">Get SQL and insights.</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 animate-slide-up">
            Transform your data queries with natural language processing.
            QueryZen converts your questions into SQL and delivers actionable
            insights with charts and summaries.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-slide-up">
            <a href="#contact" className="btn-primary text-lg px-8 py-4">
              Request Early Access
            </a>
            <a href="#how-it-works" className="btn-secondary text-lg px-8 py-4">
              See How It Works
            </a>
          </div>

          <div className="mt-12 animate-fade-in">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-2xl mx-auto">
              <div className="flex items-center mb-4">
                <div className="flex space-x-2">
                  <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                  <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                  <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                </div>
              </div>
              <div className="text-left">
                <p className="text-gray-600 mb-2">
                  💬 &ldquo;Show me our top customers by revenue this
                  quarter&rdquo;
                </p>
                <div className="bg-gray-50 rounded p-3 text-sm font-mono text-gray-800">
                  SELECT customer_name, SUM(revenue) as total_revenue
                  <br />
                  FROM orders WHERE quarter = &apos;Q3 2024&apos;
                  <br />
                  GROUP BY customer_name
                  <br />
                  ORDER BY total_revenue DESC LIMIT 10;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
